import Rebase from 're-base';

const base = Rebase.createClass({
  apiKey: "AIzaSyD5IBCZFPzCid_ZI1rIsvrcoIkcyqCWnS4",
  authDomain: "catch-of-the-day-91c04.firebaseapp.com",
  databaseURL: "https://catch-of-the-day-91c04.firebaseio.com"
});

export default base;


/** WEBPACK FOOTER **
 ** ./src/base.js
 **/